// lib
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { batch } from "react-redux";
import { useHistory } from "react-router-dom";
// src
import Table from "containers/plannings/table/Table";

const Home = ({
  // data props
  needsRefresh,
  needsUserState,
  redirectTarget,
  // action props
  fetchPopulars,
  fetchEnableds,
  fetchUserState,
  resetRedirect,
}) => {
  const history = useHistory();
  const [doProceed, setDoProceed] = useState(false);
  useEffect(() => setDoProceed(true), []);

  useEffect(() => {
    if (redirectTarget) {
      history.push(redirectTarget);
      resetRedirect();
    }
  }, [history, resetRedirect, redirectTarget]);

  if (doProceed && needsRefresh) {
    // hard refresh may be sent from global state (for instance at startup
    // or after login or when app becomes idle and active again)
    batch(() => {
      fetchPopulars();
      if (needsUserState) fetchUserState();
      fetchEnableds();
      setDoProceed(false);
    });
  }
  return <Table />;
};

Home.propTypes = {
  // data props
  needsRefresh: PropTypes.bool.isRequired,
  needsUserState: PropTypes.bool.isRequired,
  redirectTarget: PropTypes.string,
  // action props
  fetchPopulars: PropTypes.func.isRequired,
  fetchEnableds: PropTypes.func.isRequired,
  fetchUserState: PropTypes.func.isRequired,
  resetRedirect: PropTypes.func.isRequired,
};

Home.defaultProps = {
  redirectTarget: null,
};

export default Home;
